export const SET_ACTIVE_LANGUAGE = '@@localize/SET_ACTIVE_LANGUAGE'

export const defaultState = {
    selectedLanguage: "en-GB"
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_ACTIVE_LANGUAGE:
      return {
        ...state,
        selectedLanguage: action.payload.languageCode
      }
    default:
      return state
  }
}
